/**
 * 泉港H5 1.0的api请求
 */
import request from "@/libs/requestNoAuth";

export const queryParkingRecordByCarNo = (data = {}) => {
    return request({
        url: "/qgvip/parkingFeeSearchController/queryParkingRecordByCarNo",
        method: "post",
        data: data,
    });
};

export const queryMyParkingRecordDetail = (data = {}) => {
    return request({
        url: "/qgvip/myParkingRecordController/queryMyParkingRecordDetail",
        method: "post",
        data: data,
    });
};

// 发起路内外聚合停车缴费APP支付或H5支付或余额充值
export const submitParkingOrderFromApp = (data = {}) => {
    return request({
        url: "/qgvip/myParkingRecordController/submitParkingOrderFromApp",
        method: "post",
        data: data,
    });
};

// 获取弹窗活动

export const getPopupActivit = (data = {}) => {
    return request({
        url: "/qgtcapp/takeCouponController/getPopupActivit",
        method: "post",
        data: data,
    });
};

export const unionPayReturn = (data = {}) => {
    return request({
        url: "/qgpayment/unionPayNotifyController/unionPayReturn",
        method: "get",
        params: data,
    });
};

export const insertPaymentOnBehalfValidCode = (data) => {
    return request({
        url: "/qgzlpt/configManageController/insertPaymentOnBehalfValidCode",
        method: "post",
       params: data,
    })
}

export const getPaymentOnBehalfValidCode = (data) => {
    return request({
        url: "/qgzlpt/configManageController/getPaymentOnBehalfValidCode",
        method: "post",
        params: data,
    })
}
